module.exports = "/_next/static/images/Hero-6eccde064bf08a2b161c998598792032.webp";